<template>
  <v-container text-xs-center>
    <v-card class="elevation-5">
      <!-- Styled Tabs Container -->
      <div class="tabs-container">
        <v-tabs
          v-model="tab"
          dark
          background-color="light-blue darken-4"
          show-arrows
          class="centered-tabs"
        >
          <!-- <v-tab :value="'meetReport'">Meet Report</v-tab>
          <v-divider vertical class="tab-divider" /> -->
          <v-tab :value="0">Groups</v-tab>
          <v-divider vertical class="tab-divider" />
          <v-tab :value="1">Group Fees</v-tab>
          <v-divider vertical class="tab-divider" />
          <v-tab :value="2">Group Program</v-tab>
          <v-divider vertical class="tab-divider" />
          <v-tab :value="3">Workout Schedule</v-tab>
          <v-divider vertical class="tab-divider" />
          <v-tab :value="4">Records</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- Meet Report -->
          <!-- <v-tab-item key="meetReport">
            <v-card>
              <v-layout>
                <v-flex xs2 lg2>
                  <v-autocomplete
                    v-model="athleteId"
                    :rules="athleteRules"
                    required
                    :hint="`${athleteId}`"
                    label="Select Athlete Name"
                    :items="getAthletes()"
                    item-value="athleteId"
                    :item-text="text"
                  >
                  </v-autocomplete>
                </v-flex>
              </v-layout>
              <v-flex>
                <athleteResults />
              </v-flex>
              <v-flex>
                <athleteRanks />
              </v-flex>
            </v-card>
          </v-tab-item> -->

          <!-- Groups -->
          <v-tab-item :value="0">
            <groups />
          </v-tab-item>

          <v-tab-item :value="1">
            <!-- <groupFees :groupEdges="GroupInfo()" @refresh="refetchGroups" /> -->
            <groupFees :groupEdges="GroupInfo()"/>
          </v-tab-item>

          <!-- Group Program -->
          <v-tab-item :value="2">
            <groupProgram />
          </v-tab-item>

          <!-- Workout Schedule -->
          <v-tab-item :value="3">
            <workoutSchedule />
          </v-tab-item>

          <!-- Records -->
          <v-tab-item :value="4">
            <records />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>
  </v-container>
</template>
<script>
//import athleteAttendance from "./AthleteAttendance.vue";

// import athleteResults from "./AthleteResults.vue";
// import athleteRanks from "./AthleteRanks.vue";
import groupProgram from "./GroupProgram.vue";
import workoutSchedule from "./WorkoutSchedule.vue";
import groups from "./GroupList.vue";
import groupFees from "./GroupFeesTable.vue";
import records from "../league/Records.vue";
//import athleteList from "./AthleteList.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    groups,
    groupProgram,
    workoutSchedule,
    records,
    groupFees
  },
  data() {
    return {
      tabMap: {
        groups: 0,
        groupFees: 1,
        groupProgram: 2,
        workoutSchedule: 3,
        records: 4
      },
      tabReverseMap: {
        0: "groups",
        1: "groupFees",
        2: "groupProgram",
        3: "workoutSchedule",
        4: "records"
      },
      tab: "groups",
      isFormValid: true,
      status: "active",
      search: "",
      athleteId: "",
      athleteRules: [v => !!v || "Athlete is required"]
    };
  },
  created() {
    this.handleGetAthleteResults();

    //this.handleGetAthleteList();
  },
  watch: {
    tab(newTab) {
      const tabName = this.tabReverseMap[newTab];
      if (this.$route.query.tab !== tabName) {
        this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query: { tab: tabName }
        });
      }
    }
  },
  computed: {
    ...mapGetters(["loading", "clubInfo", "athleteList", "athleteResults"]),
    text() {
      return item => `${item.firstName} ${item.lastName}`;
    }
  },
  methods: {
    GroupInfo() {
      return this.clubInfo.edges
        .filter(item => item.node.clubId == this.$route.params.club)[0]
        .node.team.edges.filter(group => group.node.visibility == 1);
    },
    updateTabQuery(tabName) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: { tab: tabName } // don't keep old query keys
      });
    },
    onTabChange(newTab) {
      this.replaceWithTabQuery(newTab);
    },
    replaceWithTabQuery(tabName) {
      // Replace entire query string with only ?tab=...
      this.$router.replace({
        path: this.$route.path,
        query: {
          tab: tabName
        }
      });
    },
    handleGetAthleteResults() {
      //reach out of Vuex store, fire action that gets posts for carousel
      if (
        this.athleteResults === undefined ||
        this.athleteResults.length == 0
      ) {
        this.$store.dispatch("allResults", {
          clubId: this.$route.params.club
        });
      }
    },
    getAthletes: function() {
      return Array.from(
        new Set(this.athleteResults.edges.map(item => item.node.athleteId))
      ).map(athleteId => {
        return {
          athleteId: athleteId,
          firstName: this.athleteResults.edges.find(
            item => item.node.athleteId === athleteId
          ).node.athlete.firstName,
          lastName: this.athleteResults.edges.find(
            item => item.node.athleteId === athleteId
          ).node.athlete.lastName
        };
      });
    }
  },
  mounted() {
    const queryTab = this.$route.query.tab;

    if (queryTab && this.tabMap[queryTab] !== undefined) {
      this.tab = this.tabMap[queryTab];
    } else {
      this.tab = this.tabMap.groups; // fallback to groups
      this.$router.replace({
        ...this.$route,
        query: {
          ...this.$route.query,
          tab: "groups"
        }
      });
    }
  }
};
</script>
<style>
.centered-tabs {
  justify-content: center;
}

.tab-divider {
  margin: 0 8px;
  align-self: center;
}
</style>